var script_loaded = false;

function loadJSscripts() {
  if (script_loaded) return;

  if (typeof observer !== "undefined") {
    observer.disconnect();
  }

  script_loaded = true;

  // Lazy-load iframes
  document.querySelectorAll("iframe.lazy").forEach(iframe => {
    const dataSrc = iframe.dataset.src;
    if (dataSrc) {
      iframe.src = dataSrc;
    }
  });

  // Lazy-load scripts
  const scripts = document.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i];
    const dataSrc = script.getAttribute("data-src");

    if (dataSrc) {
      script.setAttribute("src", dataSrc);
      delete script.dataset.src;
    }

    if (script.getAttribute("type") === "text/lazyload") {
      const newScript = document.createElement("script");

      for (let j = 0; j < script.attributes.length; j++) {
        const attr = script.attributes[j];
        newScript.setAttribute(attr.name, attr.value);
      }

      newScript.type = "text/javascript";
      newScript.text = script.text;

      const parent = script.parentNode;
      parent.removeChild(script);
      parent.appendChild(newScript);
    }
  }

  // Lazy-load stylesheets
  const links = document.getElementsByTagName("link");
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    const dataHref = link.getAttribute("data-href");
    if (dataHref) {
      link.setAttribute("href", dataHref);
      delete link.dataset.href;
    }
  }

  // Notify that lazy content has been loaded
  document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
}

// Trigger on any user interaction
const activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove"
];

activityEvents.forEach(event =>
  window.addEventListener(event, loadJSscripts, { once: true, passive: true })
);

// Optional: fallback on window load
window.addEventListener("load", () => {});
